export default "__VITE_ASSET__DWXAlrKE__"